module.exports = __webpack_public_path__ + "static/media/Cream & Pudding Cakes.8dbe5249.jpg";